// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__woxv5 form_form__a6yyo","img":"ProfileForm_img__3UOJt","avatar":"ProfileForm_avatar__2sNRA"};